import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-electric bg-white" data-id="element-69" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-70" data-mp="4lqjwydxzh4k" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-4 sm:px-6 sm:pb-8 sm:pt-6" data-id="element-71" data-mp="4n9z0lnv3m4r">
        <h1 className="mx-auto max-w-4xl text-center text-[26px] leading-[1.05] text-navy sm:text-5xl" data-id="element-72" data-mp="128fs5pz8mpyv">
          The complete visual fault-finding system{' '}
          <span className="text-electric" data-id="element-73" data-mp="sbb5lp1hcshj">for home appliance technicians</span>
        </h1>
        <p className="mx-auto mt-2 w-fit rounded bg-navy px-3 py-1 text-center font-display text-sm font-extrabold uppercase tracking-wide text-white sm:text-lg" data-id="element-74" data-mp="nc88cqrqrqk4">
          Stop guessing. Start diagnosing the fault.
        </p>

        <div className="mx-auto mt-2.5 max-w-3xl space-y-1.5 text-center text-sm font-medium leading-snug text-muted sm:text-base" data-id="element-75" data-mp="3825zouknofnh">
          <p data-id="element-76" data-mp="3j923fiwkdgsw">
            Everything you need to identify appliance symptoms, check possible causes,
            test key components, and follow structured fault-finding paths—
            <strong className="font-bold text-navy" data-id="element-77" data-mp="399bahlnnj9ux">
              in one complete visual diagnostic system.
            </strong>
          </p>
          <p data-id="element-78" data-mp="3ebiqqnfilc32">
            Spend less time jumping between scattered resources and build a clearer way
            to check, test, isolate, and diagnose common home appliance faults.
          </p>
        </div>

        <MockupImage className="mt-3" priority data-id="element-79" data-mp="35akifsy1mieo" />

        <div className="mt-3 flex flex-col items-center" data-id="element-80" data-mp="2qkwmz8cjmdyv">
          <CTAButton href={OFFER_ANCHOR} data-id="element-81" data-mp="2viy4houbm588">🚀 YES! I WANT MY DIAGNOSTIC SYSTEM NOW</CTAButton>
          <TrustLine items={['🛡️ 7-Day Money-Back Guarantee — Zero Risk']} data-id="element-82" data-mp="2hj5e5umphr0s" />
        </div>
      </div>
    </section>;
}